// extracted by mini-css-extract-plugin
export default {"main_container":"Tnc_main_container__Pzj9v","container":"Tnc_container__prd0F","title":"Tnc_title__dr-Bq","desc":"Tnc_desc__Cik22"};